import * as notificationTemplatesApi from '@/api/notificationTemplates/notificationTemplates'

const notificationTemplates = {
  state: {},
  mutations: {},
  actions: {
    getNotificationTemplates ({ commit }, data) {
      return new Promise((resolve, reject) => {
        notificationTemplatesApi.getNotificationTemplates(data).then(res => {
          if (res.code === 2000) {
            resolve(res.data)
          } else {
            reject(res.message)
          }
        })
      })
    },

    showNotificationTemplate ({ commit }, data) {
      return new Promise((resolve, reject) => {
        notificationTemplatesApi.showNotificationTemplate(data).then(res => {
          if (res.code === 2000) {
            resolve(res.data)
          } else {
            reject(res.message)
          }
        })
      })
    },

    updateNotificationTemplate ({ commit }, data) {
      return new Promise((resolve, reject) => {
        notificationTemplatesApi.updateNotificationTemplate(data).then(res => {
          if (res.code === 2000) {
            resolve()
          } else {
            reject(res.message)
          }
        })
      })
    },
  }
}

export default notificationTemplates
